import type React from 'react';
import type { CSSProperties } from 'react';
import { tileClusterGeometry } from './board-layout';
import type { TileCluster } from './board-types';
import styles from './tile-cluster.module.scss';

interface TileClusterShapeProps {
  cluster: TileCluster;
  cellSize: number;
  gap: number;
  padding: number;
}

/**
 * One continuous shape around a cluster of touching tiles, in place of per-tile chrome: the tiles of
 * the cluster render their letters only (`bare`), so the shape is the whole group's surface.
 */
export const TileClusterShape: React.FC<TileClusterShapeProps> = ({ cluster, cellSize, gap, padding }) => {
  const { left, top, width, height, outline, edge, face } = tileClusterGeometry(cluster, cellSize, gap, padding);

  return (
    <svg
      aria-hidden="true"
      className={styles.cluster}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ '--cluster-left': `${left}px`, '--cluster-top': `${top}px` } as CSSProperties}
    >
      <path d={outline} fill="var(--wh-ink)" />
      <path d={edge} fill="var(--wh-tile-edge)" />
      <path d={face} fill="var(--wh-tile-face)" />
    </svg>
  );
};
